"use strict";

exports.__esModule = true;
var _DataItemValueElement = require("./DataItemValueElement");
Object.keys(_DataItemValueElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DataItemValueElement[key]) return;
  exports[key] = _DataItemValueElement[key];
});
var _DataItemValueFields = require("./DataItemValueFields");
Object.keys(_DataItemValueFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DataItemValueFields[key]) return;
  exports[key] = _DataItemValueFields[key];
});
var _DataItemValueThumbnail = require("./DataItemValueThumbnail");
Object.keys(_DataItemValueThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DataItemValueThumbnail[key]) return;
  exports[key] = _DataItemValueThumbnail[key];
});
var _DataItemValueHeader = require("./DataItemValueHeader");
Object.keys(_DataItemValueHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DataItemValueHeader[key]) return;
  exports[key] = _DataItemValueHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});